import authService, { type Store } from './authService';
import adminAllStoresService from './adminAllStoresService';
import { normalizeStoresForDropdown } from '../utils/normalizers/storeNormalizers';

const STORE_DROPDOWN_PAGE_SIZE = 500;

export const loadStoreDropdownOptions = async (): Promise<Store[]> => {
  const userDetails = JSON.parse(localStorage.getItem('userDetails') || 'null');
  if (userDetails?.is_super_admin) {
    // This endpoint includes effective subscription status for manual overrides.
    const response = await adminAllStoresService.getAllStores({});
    const stores = response.stores
      .filter((store) => ['active', 'trial', 'pending_cancel', 'past_due'].includes(store.subscription_status || ''))
      .map((store) => ({
        id: store.id,
        name: store.name,
        address_line1: store.address_line1 || undefined,
        subscription_status: store.subscription_status || undefined,
      }));
    return normalizeStoresForDropdown(stores);
  }

  const allStores: Store[] = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    const storesResp = await authService.getStores({
      page,
      page_size: STORE_DROPDOWN_PAGE_SIZE,
    });

    allStores.push(...(storesResp.stores || []));
    hasNext = Boolean(storesResp.has_next);
    page += 1;
  }

  return normalizeStoresForDropdown(allStores);
};

